import * as types from '../../config/actionTypes';
import * as SimplyBookServices from '../../services/simplyBookService';

function requestToken(nextAction){
    if(!nextAction){
        console.warn('no valid next action');
        return null;
    }

    return function(dispatch, getState){
        let currentState = getState();

        if(!currentState.simplyBook.initiated){
            SimplyBookServices.requestToken()
                .then((token) => {
                    if(token){
                        dispatch(initiated())
                        dispatch(nextAction())
                    }else{
                        // TODO: Handle catch
                    }
                })
                .catch((error) => {
                    console.log('someting wong');
                })
        }
    }
}

function initiated() {
    return {
        type: types.RECEIVED_ACCESS_TOKEN
    }
}

export function getUnits(){
    return function(dispatch, getState){
        let currentState = getState();

        if(!currentState.simplyBook.initiated){
            dispatch(requestToken(getUnits));
            return null;
        }

        SimplyBookServices.getUnits()
            .then((response) => {
                dispatch(receivedUnitList(response.result))
            })
    }
}

export function makeBooking(data){
    return function(dispatch, getState){

    }
}

export function getEvents() {
    return function(dispatch, getState){
        let currentState = getState();

        if(!currentState.simplyBook.initiated){
            dispatch(requestToken(getEvents));
            return null;
        }

        SimplyBookServices.getEvents()
            .then((response) => {
                dispatch(receivedEventList(response.data.result));
            })
    }
}

export function prepareBooking(availability, event){
    return {
        type: types.PREPARE_BOOKING,
        payload: {
            availability, event
        }
    }
}

export function resetEvent(){
    return {
        type: types.RESET_EVENT_BOOKING
    }
}

function receivedEventList(events){
    return {
        type: types.RECEIVED_EVENT_LIST,
        payload: {
            events
        }
    }
}

function receivedUnitList(units){
    return {
        type: types.RECEIVED_UNIT_LIST,
        payload: {
            units
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/actions/simplyBook.actions.js